/**
 * SecurityTab - Tab pentru setări de securitate în ProfilePage
 * 
 * Wrapper pentru componenta MFASettings existentă
 */

import React from 'react';
import { Box } from '@mui/material';
import MFASettings from '../MFASettings';

const SecurityTab: React.FC = () => {
  return (
    <Box>
      <MFASettings />
    </Box>
  );
};

export default SecurityTab;

